export const isBrowser = "object" !== "undefined";
